export const fusionarUsuariosConClasificacion = (usuarios, clasificaciones) => {
  const porId = new Map(clasificaciones.map(({ id, ocultoEnListados, usuarioPrueba }) => [id, {
    ocultoEnListados: ocultoEnListados === true, usuarioPrueba: usuarioPrueba === true,
  }]));
  const idsConPerfil = new Set(usuarios.map(usuario => usuario.id));
  return [
    ...usuarios.map(usuario => ({ ...usuario, ...porId.get(usuario.id) })),
    ...clasificaciones.filter(item => !idsConPerfil.has(item.id)).map(item => ({
      id: item.id, ...porId.get(item.id), soloClasificacion: true,
    })),
  ];
};
